import './reading-time.style.scss';
import { i18n } from '../../../internationalize/i18n.service';

export class ArticleReadingTimeComponent extends HTMLElement {
    private articleContainer: HTMLElement = document.querySelector('.content-section')!;
    private wordsPerMinute: number = 250;
    private minReadingTime: number = 1;

    constructor() {
        super();
    }

    connectedCallback() {
        document.addEventListener("premiumContentLoaded", () => {
            // Small delay to ensure premium content is fully rendered
            setTimeout(() => this.calculateAndDisplayReadingTime(), 100);
        });
    }

    /**
     * Calculate reading time based on text content
     * @param text - The text content to analyze
     * @returns Reading time in minutes
     */
    private calculateReadingTime(text: string): number {
        // Remove HTML tags and normalize whitespace
        const cleanText = text.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();

        // Count words (split by whitespace and filter out empty strings)
        const wordCount = cleanText.split(/\s+/).filter(word => word.length > 0).length;

        // Calculate reading time
        const readingTime = Math.max(this.minReadingTime, Math.ceil(wordCount / this.wordsPerMinute));

        return readingTime;
    }

    /**
     * Get all text content from the content section
     * @param container - The content container element
     * @returns Combined text content
     */
    private getContentText(container: HTMLElement): string {
        let text = '';

        // All article content (both free and premium) has the text-rich-text class
        const contentElements = container.querySelectorAll('.text-rich-text');
        if (!contentElements) { console.warn("No content found for reading time") }

        contentElements.forEach(element => {
            text += element.textContent + ' ';
        });

        return text;
    }

    /**
     * Calculate and display the reading time
     */
    private calculateAndDisplayReadingTime() {
        if (!this.articleContainer) {
            console.warn('Reading time component: .content-section not found');
            return;
        }

        // Get the text content
        const contentText = this.getContentText(this.articleContainer);
        if (!contentText.trim()) {
            console.warn('Reading time component: No content found');
            return;
        }

        // Calculate reading time
        const readingTimeMinutes = this.calculateReadingTime(contentText);
        const minutesText = readingTimeMinutes === 1 ? '1 minute' : `${readingTimeMinutes} minutes`;

        // Update the component's content
        this.innerHTML = `
            <span class="reading-time-label">${i18n.t('reading_time_label')}</span>
            <span class="reading-time-value">${minutesText}</span>
        `;
    }
}
